import React from "react";
import { Route, Switch } from "react-router-dom";

import { USER_LICENSE } from "constants/routes";
import { Admins } from "constants/userRoles";

import UserLicenseDetail from "views/UserLicense/UserLicenseDetail";
import UserLicenseEdit from "views/UserLicense/UserLicenseEdit";
import CellPhoneCreate from "views/UserLicense/CellPhone/CellPhoneCreate";
import SipDeviceCreate from "views/UserLicense/SipDevice/SipDeviceCreate";
import DidNumberCreate from "views/UserLicense/DidNumber/DidNumberCreate";

const UserLicenseRoutes = () => (
  <Switch>
    <Route
      exact
      path={USER_LICENSE.CREATE_CELL_PHONE}
      component={Admins(CellPhoneCreate)}
    />
    <Route
      exact
      path={USER_LICENSE.CREATE_DID_NUMBER}
      component={Admins(DidNumberCreate)}
    />
    <Route
      exact
      path={USER_LICENSE.CREATE_SIP_DEVICE}
      component={Admins(SipDeviceCreate)}
    />
    <Route path={USER_LICENSE.EDIT} component={Admins(UserLicenseEdit)} />
    <Route path={USER_LICENSE.SHOW} component={UserLicenseDetail} />
  </Switch>
);

export default UserLicenseRoutes;
